import { useEffect, useState } from 'react';

const QUERY = '(pointer: coarse)';

function leer(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

/**
 * true en tablet/celular (puntero "coarse": dedo), false en laptop/computadora
 * (mouse/trackpad, puntero "fine"). Se usa para decidir el modo por defecto
 * de la pantalla de puerta: cámara a pantalla completa en táctil, buscador
 * enfocado en escritorio.
 */
export function useDispositivoTactil(): boolean {
  const [tactil, setTactil] = useState(leer);

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setTactil(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return tactil;
}
